import axios from "axios";
import { SERVER_API } from "../../Constant";

export const fetchEmailData_Api = async () => {
    try {
        const response = await axios.get(`${SERVER_API}/Emails/get_triggered_emails.php`);
        return response.data;
    } catch (error) {
        console.error("Fetch triggered emails data failed:", error);
        return { error: "Fetch triggered emails data failed" };
    }
};